/**
 * Short IM-style notification (Web Audio API). No external asset required.
 */
export function playChatNotificationSound() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;

    const ctx = new Ctx();
    const master = ctx.createGain();
    master.gain.value = 0.12;
    master.connect(ctx.destination);

    const playTone = (freq, start, duration) => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, start);
      g.gain.setValueAtTime(0.0001, start);
      g.gain.exponentialRampToValueAtTime(0.35, start + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, start + duration);
      osc.connect(g);
      g.connect(master);
      osc.start(start);
      osc.stop(start + duration + 0.02);
    };

    const t0 = ctx.currentTime;
    playTone(880, t0, 0.06);
    playTone(1174, t0 + 0.07, 0.07);

    const stopAt = t0 + 0.25;
    master.gain.setValueAtTime(0.12, t0);
    master.gain.exponentialRampToValueAtTime(0.0001, stopAt);
    setTimeout(() => {
      try {
        ctx.close();
      } catch {
        /* ignore */
      }
    }, 300);
  } catch (err) {
    console.log('Chat notification sound failed:', err);
  }
}
